import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿Es difícil de usar para los invitados mayores?',
    answer: '¡Para nada! El espejo es completamente intuitivo — solo tocan la pantalla y listo. Nuestro atendente está siempre presente para ayudar a quien lo necesite.'
  }, {
    question: '¿Qué pasa si el espejo falla durante el evento?',
    answer: 'Llegamos con equipo de respaldo y soporte técnico. Tu evento nunca se detiene.'
  }, {
    question: '¿Puedo personalizar el diseño de las fotos con mi tema?',
    answer: 'Absolutamente. Cada diseño se hace específicamente para tu evento — colores, nombres, fecha, tema.'
  }, {
    question: '¿Cuántas fotos pueden tomarse?',
    answer: 'Fotos ilimitadas durante el tiempo del evento. Todos los invitados que quieran.'
  }, {
    question: '¿Atienden fuera de Atlanta?',
    answer: 'Sí, cubrimos el área metropolitana de Atlanta y zonas cercanas. Contáctanos para confirmar tu ubicación.'
  }, {
    question: '¿Con cuánta anticipación debo reservar?',
    answer: 'Recomendamos mínimo 4–8 semanas antes. Para fechas de temporada alta, cuanto antes mejor.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="preguntas" className="py-20 md:py-28 bg-ink relative" data-id="element-131">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-4" data-id="element-134">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-135"></div>
        </div>

        <div className="space-y-4" data-id="element-136">
          {faqs.map((faq, index) => <div key={index} className="bg-charcoal border border-gold/10 rounded-xl overflow-hidden" data-id="element-137">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-138">
                <span className="font-medium text-cream pr-4" data-id="element-139">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-140" />
              </button>

              <AnimatePresence data-id="element-141">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-142">
                    <div className="px-6 pb-5 text-cream/70 font-light border-t border-white/5 pt-4" data-id="element-143">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}